import React from 'react'
import { Link } from 'react-router-dom'
import AnimatedBackground from '../components/AnimatedBackground'
import GlassCard from '../components/UI/GlassCard'
import FormField from '../components/Forms/FormField'
import NameFieldsRow from '../components/NameFieldsRow'
import TermsText from '../components/TermsText'
import Divider from '../components/UI/Divider'
import LoadingSpinner from '../components/UI/LoadingSpinner'
import GradientButton from '../components/UI/GradientButton'
import { useRegistration } from '../hooks/useRegistration'

const Register = () => {
    const { values, handleChange, handleSubmit, isLoading, error } = useRegistration()

    return (
        <div className="min-h-screen relative flex items-center justify-center p-4">
            <AnimatedBackground />
            <div className="w-full max-w-md">
                {/* Logo/Brand Section */}
                <div className="text-center mb-8">
                    <h1 className="text-4xl font-bold text-white mb-2">Main Stage</h1>
                    <p className="text-gray-300">Join the creative community</p>
                </div>

                {/* Registration Form */}
                <GlassCard>
                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* Name Fields Row */}
                        <NameFieldsRow
                            firstName={values.firstName}
                            lastName={values.lastName}
                            onChange={handleChange}
                        />

                        {/* Email Field */}
                        <FormField
                            type="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            label="Email Address"
                            placeholder="john@example.com"
                            autoComplete="email"
                            required
                        />

                        {/* Username Field */}
                        <div>
                            <FormField
                                type="text"
                                name="username"
                                value={values.username}
                                onChange={handleChange}
                                label="Username"
                                placeholder="johndoe123"
                                autoComplete="username"
                                required
                                className="mb-1"
                            />
                            <p className="text-xs text-gray-400">3-20 characters, letters, numbers, underscores, dashes, @ and dots</p>
                        </div>

                        {/* Password Field */}
                        <FormField
                            type="password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            label="Password"
                            placeholder="Create a strong password"
                            autoComplete="new-password"
                            required
                        />

                        {/* Confirm Password Field */}
                        <FormField
                            type="password"
                            name="confirmPassword"
                            value={values.confirmPassword}
                            onChange={handleChange}
                            label="Confirm Password"
                            placeholder="Confirm your password"
                            autoComplete="new-password"
                            required
                        />

                        {/* Error Message */}
                        {error && (
                            <div className="bg-red-500/20 border border-red-500/50 text-red-200 px-4 py-3 rounded-xl text-sm">
                                {error}
                            </div>
                        )}

                        {/* Terms and Conditions */}
                        <TermsText />

                        {/* Register Button */}
                        <GradientButton
                            type="submit"
                            disabled={isLoading}
                            className="w-full"
                        >
                            {isLoading ? <LoadingSpinner text="Creating account..." /> : "Create Account"}
                        </GradientButton>

                        <Divider text="Already have an account?" />

                        {/* Login Link */}
                        <Link
                            to="/"
                            className="w-full block text-center bg-white/10 hover:bg-white/20 text-white font-semibold py-3 px-6 rounded-xl border border-white/20 hover:border-white/40 transition-all duration-300 hover:shadow-lg"
                        >
                            Sign In Instead
                        </Link>
                    </form>
                </GlassCard>

                {/* Footer */}
                <div className="text-center mt-8 text-gray-400 text-sm">
                    <p>© 2024 Main Stage. Built for creators.</p>
                </div>
            </div>
        </div>
    )
}

export default Register